import { connect } from 'react-redux';
import reduxForm from 'redux-form/lib/reduxForm';
import RequestResetPassword from '../RequestResetPassword';
import {
  submitRequestResetPasswordForm,
  showLogin,
  validateEmail,
} from '../../user';

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(submitRequestResetPasswordForm(data)),
  clickLogIn: () => dispatch(showLogin('Log In')),
});

export default connect(
  null,
  mapDispatchToProps
)(
  reduxForm({
    form: 'requestResetPassword',
    validate: validateEmail,
  })(RequestResetPassword)
);
